export const entityPermissions = ['can_manage_entity', 'can_view_entity'];
